module.exports = __webpack_public_path__ + "b7c05a091bbcaab7ba781384d2bec287.svg";